import { OptionTitle } from "./OptionTitle"

export const YesNoOptions: Array<OptionTitle> = [
  { title: "Yes", id: "YES" },
  { title: "No", id: "NO" },
  { title: "My journey is not going as planned", id: "SENSITIVE_SCENARIO" }
]
